import { c as _c } from "react/compiler-runtime";
import { useIntl } from "react-intl";
import FormItem from "forms/fields/FormItem";
import type { FieldProps } from "forms/fields/Languages/types";
import parseDictionary from "forms/helpers/parseDictionary";
import { predefinedFields } from "types/predefinedFields";
import { Select } from "ui/Select/Select";
import { FormField } from "uiShadcn/form";
export default function LanguagesLevelField(t0) {
  const $ = _c(14);
  const {
    control,
    index,
    isRequired,
    enumValues,
    enumNames
  } = t0;
  const {
    formatMessage
  } = useIntl();
  const name = `${predefinedFields.languages}.${index}.level`;
  let t1;
  if ($[0] !== enumNames || $[1] !== enumValues) {
    t1 = parseDictionary({
      enumNames,
      enumValues
    });
    $[0] = enumNames;
    $[1] = enumValues;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const languagesLevels = t1;
  let t2;
  if ($[3] !== languagesLevels) {
    t2 = Object.entries(languagesLevels).map(_temp);
    $[3] = languagesLevels;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const dictionary = t2;
  let t3;
  if ($[5] !== dictionary || $[6] !== formatMessage || $[7] !== index || $[8] !== isRequired) {
    t3 = t4 => {
      const {
        field
      } = t4;
      return <FormItem label={formatMessage({
        id: "languageLevel"
      })} required={isRequired}><Select ref={field.ref} dataTestId={`Select-[${index}].languageLevel`} defaultValue={field.value} onValueChange={field.onChange} required={isRequired} options={dictionary} placeholder={formatMessage({
          id: "select"
        })} /></FormItem>;
    };
    $[5] = dictionary;
    $[6] = formatMessage;
    $[7] = index;
    $[8] = isRequired;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== control || $[11] !== name || $[12] !== t3) {
    t4 = <FormField control={control} name={name} render={t3} />;
    $[10] = control;
    $[11] = name;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}
function _temp(t0) {
  const [value, label] = t0;
  return {
    key: value,
    value: label
  };
}